import Pusher from 'pusher-js';

let pusher = null;

export default function createPusher() {
  if (!pusher) {
    pusher = new Pusher(process.env.PUSHER_APP_KEY, {
      wsHost: process.env.PUSHER_EM_HOST,
      wsPort: process.env.PUSHER_EM_PORT,
      wssPort: process.env.PUSHER_EM_PORT,
      encrypted: process.env.PUSHER_EM_SSL === 'true',
      disableFlash: false,
      disableStats: true,
      enabledTransports: ['ws', 'flash'],
      activityTimeout: 120000,
      pongTimeout: 30000,
    });
  }
  return pusher;
}
